import Main from './components/Main';
import './styles/App.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <>
      <Main />
    </>
  );
}
export default App;